import { defaultAuthState, DefaultUser } from '../../models/redux/DefaultAuthState';
import * as types from './types';

const AuthReducer = (state = defaultAuthState, action: any) => {
  switch (action.type) {
    case types.AUTH_USER_LOGIN_RECEIVE: {
      state = {
        ...state,
        user: action.payload,
        isLoggedIn: true,
        roles: action.payload.roles
      };
      break;
    }
    case types.AUTH_USER_LOGIN_ERROR: {
      state = {
        ...state,
        user: DefaultUser,
        isLoggedIn: false,
        roles: [],
        rolesLoaded: false
      };
      break;
    }
    case types.AUTH_USER_DRIVER_REQUEST: {
      state = {
        ...state,
        loading: true
      };
      break;
    }
    case types.AUTH_USER_DRIVER_RECEIVE: {
      const currentUserState = state.user;
      currentUserState.driver = action.payload;
      state = {
        ...state,
        user: currentUserState,
        loading: false
      };
      break;
    }
    case types.AUTH_USER_DRIVER_ERROR: {
      state = {
        ...state,
        loading: false
      };
      break;
    }
    case types.AUTH_USER_LOGOUT_RECEIVE: {
      state = {
        ...state,
        user: DefaultUser,
        isLoggedIn: false,
        roles: []
      };
      break;
    }
    case types.AUTH_USER_LOGOUT_ERROR: {
      state = {
        ...state,
        user: DefaultUser,
        isLoggedIn: false,
        roles: [],
        rolesLoaded: false
      };
      break;
    }
    case types.AUTH_USER_SET_ROLES: {
      state = {
        ...state,
        roles: action.payload,
        rolesLoaded: true
      };
      break;
    }
    case types.REHYDRATE:
      if (action.key === 'root' && action.payload && action.payload.auth) {
        state = {
          ...action.payload.auth
        };
      }
      break;
  }
  return state;
};

export { AuthReducer };
